import StatusChip from "@entrilia/shared/components/StatusChip";

const DraftStatus = () => <StatusChip label="Draft" withDot color={(t) => t.palette.text.secondary} />;

export default DraftStatus;
